<template>
	<div>
		<div class="container remove-padding-margin">
			<div class="container remove-padding-margin" id="">
				<div class="header-top bg-white">
					<div class="row justify-content-center align-items-center set-row w-limit">
						<div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
							<img src="../../../assets/gambar/back-blue.svg" alt="">
						</div>
						<div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
							<h6 class="remove-margin font-16 font-colorcheck text-promo nomore">
								Detail Absensi
							</h6>
						</div>
						<div class="col-md-2 col-sm-2 col-2">
						</div>
					</div>
				</div>

				<div class="w-limit flex-100">
					<div class="flex-1">
						<GmapMap
							:center="latlng"
							:zoom="outletMarker.defaultOptions.zoom"
							:options="{ streetViewControl: false, disableDefaultUI: true }"
							ref="map"
							style="height: calc(100vh - 72px)">
							<GmapMarker
								:position="latlng"
								:icon="iconConfig"
							/>
						</GmapMap>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "LokasiAbsen",
		props: ["latlng"],
		data() {
			return {
				mapCenter: {
					lat: -6.175253729974098,
					lng: 106.82713133905226
				},
				iconConfig: {
					url: require('../../../assets/icons/marker-blue.svg'),
					size: {
						width: 28,
						height: 28,
						f: "px",
						b: "px"
					},
					scaledSize: {
						width: 28,
						height: 28,
						f: "px",
						b: "px"
					}
				},
				outletMarker: {
					defaultOptions: {
						zoom: 18,
						radius: 5,
					}
				},
			}
		},
		mounted() {
			this.backButtonPressed(this.back)
		},
		methods: {
			back() {
				this.$emit("back")
			},
		},
	}
</script>